// 可以外部resolve的promise

export class ResolvePromise<T> extends Promise<T> {
  resolve: (value: T) => void = null
  reject: (reason?: any) => void = null

  constructor(executor?: (resolve: (value: T) => void, reject: (reason?: any) => void) => void) {
    let resolve = null
    let reject = null
    super((res, ret) => {
      resolve = res
      reject = ret
      executor?.(res, ret)
    })
    this.resolve = resolve
    this.reject = reject
  }
}
